import React from "react";
import styled from "styled-components";

const StyledLoader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  background-image: url("/img/indicator.png");
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: -12px;
  margin-left: -15px;
  opacity: ${props => (!!props.loading ? "1" : "0")};
  animation: button-indicator-rotations 600ms linear infinite;
  transition: all 120ms ease-in-out 0ms, visibility 0ms ease-in-out 120ms;

  @keyframes button-indicator-rotations {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingIcon = ({ loading }) => <StyledLoader loading={loading} />;

export default LoadingIcon;
